var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.967,
    height: 17.967,
    viewBox: "0 0 17.967 17.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_receive-square",
    "data-name": "vuesax/outline/receive-square",
    transform: "translate(-748 -380)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "receive-square",
    transform: "translate(748 380)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H17.967V17.967H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M755.261,396.6v3.191h12.991V396.6",
    transform: "translate(-752.768 -384.424)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6000",
    "data-name": "Path 6000",
    d: "M8.7,2.9v9.065",
    transform: "translate(0.286 -0.314)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6001",
    "data-name": "Path 6001",
    d: "M158.048,10151.531l3.228,2.96",
    transform: "translate(-152.354 -10142.85)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6002",
    "data-name": "Path 6002",
    d: "M161.276,10151.531l-3.228,2.96",
    transform: "translate(-149.059 -10142.85)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.158a194bb207827c9a1d760ffb1ea953.svg";
export { ForwardRef as ReactComponent };